import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth-guard';
import { LoginauthService } from './loginauth.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';

import { AccountComponent } from './account/account.component';
import { ActivefreetrialComponent } from './activefreetrial/activefreetrial.component';
import { FreetrialtoactiveComponent } from './activefreetrial/freetrialtoactive.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ProfileComponent } from './profile/profile.component';
import { RegisterComponent } from './register/register.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { SetpasswordComponent } from './setpassword/setpassword.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

import { AddechexadminComponent } from './echexadmin/addechexadmin.component';
import { EchexadminComponent } from './echexadmin/echexadmin.component';
import { ManagepermissionsComponent } from './managepermissions/managepermissions.component';
import { MerchantusermanagepermissionsComponent } from './managepermissions/merchantusermanagepermissions.component';

import { AddechexmerchantComponent } from './echexmerchant/addechexmerchant.component';
import { EchexmerchantComponent } from './echexmerchant/echexmerchant.component';
import { EditechexmerchantComponent } from './echexmerchant/editechexmerchant.component';

//Permissions
import { PermissionAddComponent } from './permission/permission-add.component';
import { PermissionEditComponent } from './permission/permission-edit.component';
import { PermissionComponent } from './permission/permission.component';
//Invoice
import { AdmininvoiceComponent } from './admininvoice/admininvoice.component';
import { ViewinvoiceComponent } from './invoice/viewinvoice.component';
//Activity logs
import { ActivitylogComponent } from './activitylog/activitylog.component';
//Status
import { CreatestatusComponent } from './status/createstatus.component';
import { EditstatusComponent } from './status/editstatus.component';
import { StatusComponent } from './status/status.component';
//Email templates
import { CreateemailtemplateComponent } from './emailtemplates/createemailtemplate.component';
import { EditemailtemplateComponent } from './emailtemplates/editemailtemplate.component';
import { EmailtemplatesComponent } from './emailtemplates/emailtemplates.component';
//Plan
import { CreateplanComponent } from './plan/createplan.component';
import { EditplanComponent } from './plan/editplan.component';
import { PlanComponent } from './plan/plan.component';
//Send cheque
import { SendcheckComponent } from './sendcheck/sendcheck.component';
import { SendcheckprintedComponent } from './sendcheck/sendcheckprinted.component';
import { WanttoprintsendcheckComponent } from './sendcheck/wanttoprintsendcheck.component';

//Generate Url
import { BankauthUrlComponent } from './generate-bankauth-url/bankauth-url.component';
import { GenerateBankauthUrlComponent } from './generate-bankauth-url/generate-bankauth-url.component';
import { ThankYouLinkComponent } from './generate-bankauth-url/thank-you-link.component';
import { CheckoutUrlComponent } from './generate-checkout-url/checkout-url.component';
import { GenerateCheckoutUrlComponent } from './generate-checkout-url/generate-checkout-url.component';

//Create Cheque
import { CreateChequeComponent } from './create-cheque/create-cheque.component';
//Transactions
import { EditTransactionsComponent } from './transactions/edittransactions.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { LoginAuthenticationComponent } from './login-authentication/login-authentication.component';
import { PackageComponent } from './package/package.component';
import { CasherpayUsersComponent } from './casherpay-users/casherpay-users.component';
import { CreateInvoiceComponent } from './create-invoice/create-invoice.component';
import { PayInvoiceComponent } from './pay-invoice/pay-invoice.component';
import { InvoiceBankauthComponent } from './invoice-bankauth/invoice-bankauth.component';
import { InvoiceSecureauthComponent } from './invoice-secureauth/invoice-secureauth.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { EditechexmerchantuserComponent } from './editechexmerchantuser/editechexmerchantuser.component';
import { AddCustomplanComponent } from './account/addcustomplan.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [LoginauthService] },
  { path: 'get-started-deposits', component: LoginAuthenticationComponent , canActivate: [AuthGuard]},
  { path: 'get-started-plan', component: PackageComponent , canActivate: [AuthGuard]},
  { path: 'register', component: RegisterComponent, canActivate: [LoginauthService] },
  { path: 'register/:user_token', component: RegisterComponent, canActivate: [LoginauthService] },
  { path: 'thank-you', component: ThankyouComponent },
  { path: 'account/verify/:token', component: VerifyEmailComponent },
  { path: 'set-password/:user_token', component: SetpasswordComponent , canActivate: [LoginauthService]},
  { path: 'forgot', component: ForgotpasswordComponent, canActivate: [LoginauthService] },
  { path: 'reset/:token', component: ResetpasswordComponent, canActivate: [LoginauthService] },
  { path: 'reset', component: ResetpasswordComponent, canActivate: [LoginauthService] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  //{ path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'active-free-trial', component: ActivefreetrialComponent, canActivate: [AuthGuard] },
  { path: 'freetrial-to-active', component: FreetrialtoactiveComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'profile/:id', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'account', component: AccountComponent, canActivate: [AuthGuard] },
  { path: 'account/customplan', component: AddCustomplanComponent, canActivate: [AuthGuard] },
  //eChex Admin
  { path: 'echex-admin', component: EchexadminComponent, canActivate: [AuthGuard] },
  { path: 'add-echex-admin', component: AddechexadminComponent, canActivate: [AuthGuard] },
  //eChex Merchant
   { path: 'echex-merchant', component: EchexmerchantComponent, canActivate: [AuthGuard] },
   { path: 'add-echex-merchant', component: AddechexmerchantComponent, canActivate: [AuthGuard] },
   { path: 'edit-echex-merchant/:id/:merchant_id', component: EditechexmerchantComponent, canActivate: [AuthGuard] },
   { path: 'edit-echex-merchant-user/:id', component: EditechexmerchantuserComponent, canActivate: [AuthGuard] },
   { path: 'casherpay-merchant-user-permision/:role_id/:id', component: MerchantusermanagepermissionsComponent , canActivate: [AuthGuard]},
   //eChex Users
  { path: 'casherpay-users', component: CasherpayUsersComponent, canActivate: [AuthGuard] },
  //Permissions
  { path: 'echex-permisions/:role_id/:id', component:ManagepermissionsComponent, canActivate: [AuthGuard]},
  { path: 'permisions', component:PermissionComponent, canActivate: [AuthGuard]},
  { path: 'permision-add', component:PermissionAddComponent, canActivate: [AuthGuard]},
  { path: 'edit-permission/:id', component:PermissionEditComponent, canActivate: [AuthGuard]},
  
  //Invoice
  { path: 'invoice', component: AdmininvoiceComponent},
  { path: 'view-invoice/:id', component: ViewinvoiceComponent, canActivate: [AuthGuard]},
  
  // Activity logs
  { path: 'activity-logs', component: ActivitylogComponent, canActivate: [AuthGuard]},
  //Status
  { path: 'status', component: StatusComponent, canActivate: [AuthGuard]},
  { path: 'create-status', component: CreatestatusComponent, canActivate: [AuthGuard]},
  { path: 'edit-status/:id', component: EditstatusComponent, canActivate: [AuthGuard]},
  //Email Template
  { path: 'email-templates', component: EmailtemplatesComponent, canActivate: [AuthGuard]},
  { path: 'create-template', component: CreateemailtemplateComponent, canActivate: [AuthGuard]},
  { path: 'edit-template/:id', component: EditemailtemplateComponent, canActivate: [AuthGuard]},
  //Plan
  { path: 'plan', component: PlanComponent, canActivate: [AuthGuard]},
  { path: 'create-plan', component:CreateplanComponent, canActivate: [AuthGuard]},
  { path: 'edit-plan/:id', component:EditplanComponent, canActivate: [AuthGuard]},
  
  //Send Cheque
  { path: 'sendcheck', component: SendcheckComponent, canActivate: [AuthGuard]},
  { path: 'print/send/cheque/:id', component: WanttoprintsendcheckComponent},
  //{ path: 'cancel/send/cheque/:id', component: CancelSendCheckComponent},
  { path: 'printed/send/cheque/:id', component: SendcheckprintedComponent},
  
  // Generate secure and bank auth url
  {path: 'create-bank-auth-url-link', component: GenerateBankauthUrlComponent, canActivate: [AuthGuard]},
  {path: 'create-secure-url-link', component: GenerateCheckoutUrlComponent, canActivate: [AuthGuard]},
  {path: 'bank/auth/:_id/:token', component: BankauthUrlComponent},
  {path: 'thank-you-url', component: ThankYouLinkComponent},
  {path: 'secure/url/:_id/:token', component: CheckoutUrlComponent},
  //Create Cheque
  {path: 'create-cheque', component: CreateChequeComponent, canActivate: [AuthGuard]},
  // Transactions
  {path: 'transactions', component: TransactionsComponent, canActivate: [AuthGuard]},
  { path: 'edit-transaction/:id', component: EditTransactionsComponent, canActivate: [AuthGuard] },
  { path: 'create-invoice', component: CreateInvoiceComponent, canActivate: [AuthGuard]},
  { path: 'pay-invoice/:id', component: PayInvoiceComponent},
  {path: 'invoice/bank/auth/:_id/:token/:invoice_id', component: InvoiceBankauthComponent},
  {path: 'invoice/secure/url/:_id/:token/:invoice_id', component: InvoiceSecureauthComponent},
  {path: 'text-editor', component: TextEditorComponent},
  {path: 'page-not-found', component: PagenotfoundComponent},
   // Other routes
   { path: '', redirectTo: '/dashboard', pathMatch: 'full' }, // Redirect to home page
   // { path: '**', redirectTo: '/dashboard' } // Wildcard route for unmatched paths
   { path: '**', pathMatch: 'full', component: PagenotfoundComponent },
];

@NgModule({
 imports: [ RouterModule.forRoot(routes) ],
 exports: [ RouterModule ]
})



export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/app-routing.module.ts